/*------------------------------------*\
    NAV
\*------------------------------------*/
class Nav {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.hamburger = self.elem.querySelector('[data-nav-toggle]');
        self.nav = self.elem.querySelector('[data-nav]');
        self.onEscape = self.onEscape.bind(self);
        self.body = document.querySelector('body');
        self.navIsOpen = false;
    }

    init() {
        let self = this;

        self.initNavToggle();
    }

    initNavToggle() {
        let self = this;

        // On click of hamburger
        self.hamburger.addEventListener('click', evt => {
            evt.preventDefault();

            if (self.navIsOpen) {
                self.closeNav();
            } else {
                self.openNav();
            }
        });
    }

    openNav() {
        let self = this;

        // Toggle active class on header
        self.elem.classList.add('has-open-nav');
        // Toggle active class on toggle button
        self.hamburger.classList.add('is-active');
        // Toggle active class on nav
        self.nav.classList.add('is-open');
        // Toggle scrolling on body
        self.body.classList.add('is-no-scroll');

        self.addEventListeners();

        self.navIsOpen = true;
    }

    closeNav() {
        let self = this;

        // Toggle active class on header
        self.elem.classList.remove('has-open-nav');
        // Toggle active class on toggle button
        self.hamburger.classList.remove('is-active');
        // Toggle active class on nav
        self.nav.classList.remove('is-open');
        // Toggle scrolling on body
        self.body.classList.remove('is-no-scroll');

        self.removeEventListeners();

        self.navIsOpen = false;
    }

    addEventListeners() {
        let self = this;

        document.addEventListener('keydown', self.onEscape);
    }

    removeEventListeners() {
        let self = this;

        document.removeEventListener('keydown', self.onEscape);
    }

    onEscape(evt) {
        let self = this;

        if (evt.key === "Escape") {
            self.closeNav();
        }
    }
}

export default Nav;
